import React, { createContext, useContext, useState } from "react";

const ActiveChannelContext = createContext();

export const ActiveChannelProvider = ({ children }) => {
  const [hasActiveChannel, setHasActiveChannel] = useState(false);

  return (
    <ActiveChannelContext.Provider
      value={{ hasActiveChannel, setHasActiveChannel }}
    >
      {children}
    </ActiveChannelContext.Provider>
  );
};

export const useActiveChannel = () => {
  const context = useContext(ActiveChannelContext);
  if (!context) {
    throw new Error(
      "useActiveChannel must be used within ActiveChannelProvider",
    );
  }
  return context;
};
